module.exports = "/_next/static/images/9f197f9db758602d9405fe5f2b02539d-nubanker-eng@0.75x.jpg";